//
// TextTemplate.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./TextTemplateType";
import "./TemplateDefinition";
import "./TemplateLookup";

var TextTemplate = createModule("BIRD::TextTemplate", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        templateLookups: [1],
        templateDefinition: 1,
        type: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TextTemplate;
